import { useViewColumnsValidator } from '../validation';
import { ITableColumnFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { GridCell } from '../DataModelerCommonUI';
import { SvgIcon } from '../../../../components/Icon';
import KubitTooltip from '../../../../components/KubitTooltip';
import { CSSProperties } from 'react';
import { ModifiedIcon } from '../DataModelerShared';

interface IProps {
  isModified: boolean;
  tableKey: string;
  viewKey: string;
  isNew: boolean;
  fieldName: string;
  tableColumn: ITableColumnFieldsFragment;
  style: CSSProperties;
  rowIndex: number;
}

// XXX only reason to have this component is to be able to use a column-specific hook
const ModifiedGridCell = ({
  isModified,
  tableKey,
  viewKey,
  isNew,
  fieldName,
  tableColumn,
  style,
  rowIndex,
}: IProps) => {
  const { allOtherFieldNamesSet } = useViewColumnsValidator({
    tableKey,
    viewKey,
    tableColumn: tableColumn.column,
  });

  const isDuplicateNameError = isNew && allOtherFieldNamesSet.has(fieldName);

  return (
    <GridCell style={style} $isEven={rowIndex % 2 === 0}>
      {isDuplicateNameError && (
        <KubitTooltip
          content="Duplicate name error"
          placement="top-start"
          noOpenDelay={true}
        >
          <SvgIcon width={16} height={16} name={'error-icon'} />
        </KubitTooltip>
      )}
      {isModified && (
        <KubitTooltip content="Modified" noOpenDelay={true}>
          <ModifiedIcon />
        </KubitTooltip>
      )}
    </GridCell>
  );
};

export default ModifiedGridCell;
